/**
 * @module app.MapService
 */
import appBase from './index.js';

const MapService = class {

  /**
   * @ngInject
   */
  constructor() {
    /**
     * @private
     * @type {ol.Map}
     */
    this.map_;
  }

  get map() {
    return this.map_;
  }

  set map(map) {
    this.map_ = map;
  }

};

appBase.service('appMapService', MapService);


export default MapService;
